import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Row, Col } from 'react-bootstrap';
import { Input, FormActions } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='name' component={Input} type='text' label={t('Franchisee_Name')} />
						</Col>
						<Col sm={6}>
							<Field name='companyNumber' component={Input} type='text' label={t('Franchisee_CompanyNumber')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='contactPerson' component={Input} type='text' label={t('Franchisee_ContactPerson')} />
						</Col>
						<Col sm={6}>
							<Field name='isOnline' component={Input} componentClass='select' label={t('Franchisee_IsOnline')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='centerName' component={Input} type='text' label={t('Franchisee_CenterName')} />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'franchiseesFilter' })(withTranslation()(Filter));